/* eslint-disable react/prop-types */

import React, { useContext, useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { graphql } from "gatsby";
import { AppContext } from "~context/AppContext";
import { DocumentContext } from "~context/DocumentContext";
import Button from "~components/Button";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import Minus from "~components/svg/Minus";
import Carousel from "~components/Carousel";
import Plus from "~components/svg/Plus";
import Service from "~components/case-study/Service";
import TyperSection from "~components/TyperSection";
import PrimaryText from "~components/PrimaryText";
import { toggleArrayItem } from "~utils/helpers";
import LottieAnimation from "~components/LottieAnimation";
import animationJSON from "~assets/animation/Apostrophe Services Animation.json";

const ServicesPage = ({ data, location }) => {
  const {
    aLaCarte,
    setALaCarte,
    bundles,
    setBundles,
    monogamyPlan,
    setMonogamyPlan
  } = useContext(AppContext);
  const { scrollTop, device } = useContext(DocumentContext);

  const [activeTooltip, setActiveTooltip] = useState(null);
  const [selectedSomething, setSelectedSomething] = useState(false);

  const { frontmatter } = data.markdownRemark;

  //

  const activateTooltip = (e, id) => {
    e.stopPropagation();

    setActiveTooltip(id);
  };

  const toggleALaCarte = item => {
    setALaCarte(toggleArrayItem(aLaCarte, item));
  };

  const toggleBundle = item => {
    setBundles(toggleArrayItem(bundles, item));
  };

  //

  // useEffect(() => {
  //   let clickListener;

  //   if (typeof document !== `undefined`) {
  //     clickListener = document.addEventListener(`click`, e => {
  //       if (activeTooltip !== null) {
  //         // If we've just clicked on something that isn't the active tooltip container, or another tooltip button, close it
  //         const containerId = `${activeTooltip}_ttip_cont`;
  //         const allIds = frontmatter?.aLaCarte?.map(({ text }) => text);

  //         if (![containerId, ...allIds].includes(e.target.id)) {
  //           setActiveTooltip(null);
  //         }
  //       }
  //     });
  //   }

  //   return () =>
  //     clickListener && typeof document !== `undefined`
  //       ? document.removeEventListener(clickListener)
  //       : null;
  // }, [activeTooltip]);

  useEffect(() => {
    setActiveTooltip(null);
  }, [scrollTop]);

  useEffect(() => {
    if (aLaCarte.length + bundles.length !== 0) {
      setSelectedSomething(true);
    }
  }, [aLaCarte, bundles]);

  //

  const aLaCarteColumns = [[], [], []];

  if (frontmatter?.aLaCarte) {
    frontmatter.aLaCarte.map((aLaCarteItem, alacarteIndex) =>
      aLaCarteColumns[alacarteIndex % 3].push(aLaCarteItem)
    );
  }

  const aLaCarteListJSX = aLaCarteColumns.map((column, columnIndex) => {
    const key = `alacartecol_${columnIndex}`;

    return (
      <ul className="w-full relative flex flex-col xs:px-1 xs:pt-4" key={key}>
        {column.map(aLaCarteItem => {
          const selected = aLaCarte.includes(aLaCarteItem.text);
          const focused = activeTooltip === aLaCarteItem.text;
          const fontColor = selected ? `white` : `orange`;

          return (
            <Service
              servicesItem={aLaCarteItem}
              selected={selected}
              focused={focused}
              activateTooltip={activateTooltip}
              setActiveTooltip={setActiveTooltip}
              toggleALaCarte={toggleALaCarte}
              fontColor={fontColor}
            />
          );
        })}
      </ul>
    );
  });

  let bundlesJSX = [];

  if (frontmatter?.bundles) {
    bundlesJSX = frontmatter.bundles.map(bundle => {
      const selected = bundles.includes(bundle.name);

      return (
        <button
          key={bundle.name}
          type="button"
          className={`services-page__bundle ${
            selected ? `selected` : ``
          } grid-end-4 xs:w-full relative block pt-v3 xs:pt-v10 pr-v1 xs:pr-v3 pb-v2 xs:pb-v8 pl-v1 xs:pl-v3 border-orange text-left`}
          onClick={() => toggleBundle(bundle.name)}
        >
          <div className="services-page__bundle__name w-full relative flex items-start justify-between xs:mb-v4">
            <h3 className="w-5/6 b1 universal-sans">{bundle.name}</h3>

            <div style={{ marginTop: `0.66vw` }}>
              {(selected && (
                <Minus
                  className="services-page__button__plus--small animation-pop w-1/6 relative block"
                  color={`${selected ? `white` : `orange`}`}
                />
              )) || (
                <Plus
                  className="services-page__button__plus--small animation-pop w-1/6 relative block"
                  color={`${selected ? `white` : `orange`}`}
                />
              )}
            </div>
          </div>

          <p className="services-page__bundle__description b2 universal-sans xs:mb-v10">
            {bundle.description}
          </p>

          <ul className="flex flex-wrap">
            {bundle?.buttons &&
              bundle.buttons.map(button => {
                return (
                  <li
                    key={button.text}
                    className="relative block"
                    style={{
                      marginRight: device === `desktop` ? `0.5vw` : `1.5vw`,
                      marginBottom: device === `desktop` ? `0.5vw` : `1.5vw`
                    }}
                  >
                    <div
                      className={`services-page__button services-page__button--bundle services-page__bundle--${
                        button.type
                      } w-full relative flex items-center justify-between pointer-events-none bg-transparent whitespace-pre-wrap universal-sans ${
                        device === `mobile` ? `b2` : `caption`
                      }`}
                    >
                      {button.text}
                    </div>
                  </li>
                );
              })}
          </ul>
        </button>
      );
    });
  }

  return (
    <>
      <SEO
        customTitle={frontmatter.title}
        customDescription={frontmatter.seoDescription}
        customKeywords={frontmatter.seoKeywords}
        path={location.pathname}
      />

      <Layout
        className={`services-page ${
          activeTooltip ? `tooltip-active` : ``
        } w-full relative bg-white overflow-x-hidden`}
      >
        <TyperSection
          heading={frontmatter.heading}
          imageText={frontmatter.imageText}
          imageCaption={frontmatter.imageCaption}
          imageColor="moss"
          typerColor="blue"
        />

        <PrimaryText text={frontmatter.introText} />

        <section className="grid">
          <div className="grid-end-12">
            <LottieAnimation
              animation={animationJSON}
              className="index-page__animation w-full relative"
              animationOptions={{ loop: true }}
            />
          </div>
        </section>
        <div className="relative mt-v7 xs:mt-v14">
          <div className="grid text-orange">
            <div className="grid-end-6 xs:grid-end-8 mb-v4 xs:mb-v14">
              <h2 className="b1 universal-sans mb-v1 xs:mb-v5">
                {frontmatter.aLaCarteHeading}
              </h2>

              <p className="b2 universal-sans">{frontmatter.aLaCarteContent}</p>
            </div>
          </div>

          <div className="grid">
            {device === `mobile` ? (
              <Carousel
                withDots
                dotColor="orange"
                className="grid-end-12 xs:grid-end-8 relative block"
                items={aLaCarteListJSX}
                itemWidth="100%"
              />
            ) : (
              aLaCarteListJSX.map((list, listIndex) => {
                const key = `alacareListJSX_${listIndex}`;
                return (
                  <div key={key} className="grid-end-4">
                    {list}
                  </div>
                );
              })
            )}
          </div>
        </div>
        <div className="relative mt-v14">
          <div className="grid text-orange mb-v4 xs:mb-v14">
            <h2 className="grid-end-6 xs:grid-end-8 b1 universal-sans">
              {frontmatter.bundlesHeading}
            </h2>
          </div>

          <div className="grid items-start text-orange xs:pb-v7">
            {device === `mobile` ? (
              <Carousel
                items={bundlesJSX}
                withDots
                dotColor="orange"
                className="grid-end-12 xs:grid-end-8 relative block"
                itemWidth="100%"
              />
            ) : (
              bundlesJSX
            )}
          </div>
        </div>

        <div className="services-page__monogamy relative mt-v14">
          <div className="services-page__monogamy__bg w-full h-full absolute transform-center bg-sauvignon"></div>

          <div className="grid z-10 pt-v2 xs:pt-v8 text-orange">
            <div className="grid-end-6 xs:grid-end-8">
              <h2 className="xs:pl-v3 xs:pr-v3 mb-v1 xs:mb-v2 b1 universal-sans">
                {frontmatter.monogamyHeading}
              </h2>

              <p className="xs:pl-v3 xs:pr-v3 xs:pt-v6 b2 universal-sans">
                {frontmatter.monogamyContent}
              </p>
            </div>
          </div>

          <div className="grid z-10 pt-v4 pb-v2 xs:pl-v3 xs:pr-v3 text-orange">
            {frontmatter?.monogamyPlans &&
              frontmatter.monogamyPlans.map((plan, index) => {
                const selected = monogamyPlan === plan.type;
                const planKey = `${plan.type}-key-${index}`;

                return (
                  <div
                    className="grid-end-6 xs:grid-end-8 xs:mb-v2"
                    key={planKey}
                  >
                    <button
                      type="button"
                      className={`services-page__button w-full rounded-lg relative flex items-center justify-between text-left pt-v2 xs:pt-v4 pr-v2 pb-v2 xs:pb-v4 pl-v2 ${
                        selected ? `selected` : ``
                      }`}
                      onClick={() =>
                        setMonogamyPlan(selected ? null : plan.type)
                      }
                    >
                      <span
                        className={`xs:mr-v2 ${
                          device === `mobile` ? `b2` : `b1`
                        } universal-sans`}
                      >
                        {plan.type}
                      </span>

                      {(selected && (
                        <Minus
                          className="services-page__button__plus--small animation-pop relative block"
                          color={`${selected ? `white` : `orange`}`}
                        />
                      )) || (
                        <Plus
                          className="services-page__button__plus--small animation-pop relative block"
                          color={`${selected ? `white` : `orange`}`}
                        />
                      )}
                    </button>
                  </div>
                );
              })}
          </div>
        </div>

        <section className="w-full relative">
          <div className="grid">
            <div className="grid-end-12 xs:grid-end-8 flex justify-center mt-v7 xs:mt-v14 mb-v7 xs:mb-v14">
              <a href="mailto:blah@apostrophe.xyz">
                <Button className="" color="orange" filled>
                  ...or just email us the usual way
                </Button>
              </a>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

ServicesPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.shape({})
    })
  }).isRequired,
  location: PropTypes.shape({}).isRequired
};

export default ServicesPage;

export const query = graphql`
  query ServicesPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        heading
        introText
        imageText
        imageCaption
        aLaCarteHeading
        aLaCarteContent
        aLaCarte {
          description
          text
          type
        }
        bundlesHeading
        bundles {
          name
          description
          buttons {
            text
            type
          }
        }
        monogamyHeading
        monogamyContent
        monogamyPlans {
          type
        }
        seoDescription
        seoKeywords
      }
    }
  }
`;
